import React from 'react';
import { Button } from './ui/button';
import { ArrowUpRight } from 'lucide-react';

export default function Bottleneck() {
  return (
    <section id="bottleneck" className="relative py-32 lg:py-48 bg-[#B5876C] text-[#EBE4DE] overflow-hidden">
      <div className="absolute inset-0 grain" />
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative">
        <p className="text-[13px] tracking-[0.3em] uppercase text-[#EBE4DE]/70 mb-10" data-reveal>/ 05 — The Founder Bottleneck</p>
        <h2
          className="font-serif text-[42px] sm:text-[64px] lg:text-[104px] leading-[0.98] tracking-[-0.02em] font-light max-w-6xl mask-headline"
          aria-label="A business cannot scale one founder-led deal at a time."
        >
          <span className="mask-line" style={{ '--reveal-delay': '80ms' }}><span>A business cannot scale</span></span>
          <span className="mask-line" style={{ '--reveal-delay': '200ms' }}><span><em>one founder-led deal</em> at a time.</span></span>
        </h2>
        <p className="mt-12 max-w-2xl text-lg lg:text-xl leading-relaxed text-[#EBE4DE]/85 font-light" data-reveal style={{ '--reveal-delay': '360ms' }}>
          The objective is straightforward: remove the founder from daily sales tasks. We implement the structures that allow growth to continue independently.
        </p>
        <div className="mt-12" data-reveal style={{ '--reveal-delay': '480ms' }}>
          <Button asChild className="bg-[#2E2C28] hover:bg-[#EBE4DE] hover:text-[#2E2C28] text-[#EBE4DE] rounded-none h-14 px-8 text-[12px] tracking-[0.2em] uppercase transition-colors duration-500 press">
            <a href="/book" className="inline-flex items-center gap-3">
              Ready to scale past yourself?
              <ArrowUpRight size={16} strokeWidth={1.5} className="cta-arrow" />
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
}
